import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const deleteProcess = async (id) => {
        
    try {
        let {status} = await axios.delete(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/${id}`);
        
        if (status === 200) {
            addNotification({
                title: "Techforce.ai",
                message: "Action Flow has been deleted successfully",
                type: "success"
            });
        }  
        return status;

    } catch (err) {
        if(err.response.status===404){
            addNotification({
                title: "Techforce.ai",
                message: "Action Flow deletion failed as the bot id doesnot belong to user account ",
                type: "danger"
            });
        }else{
            addNotification({
                title: "Techforce.ai",
                message: "Action Flow deletion failed because it is in queue ",
                type: "danger"
            });
        }
        
    }
};